import React from 'react'

export default function About() {
    return (
        <>
            <section id="about-us">
                <div className="about-baner">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4">
                                <h4>We take pleasure in always providing our consumers with dependable services.</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                       <div className="col-12">
                            <div className="about-content">
                                <h2 className="section-title mb-3 mb-md-4">About Us</h2>
                                <h6>CWC Delivery Service is Bangladesh’s most trusted on-demand last mile logistics network offering tech-enabled one stop delivery solutions. Since its inception in 2014, our vision has been to become the operating system for e-commerce in Bangladesh, through a combination of world-class infrastructure, logistics operations of the highest quality and cutting-edge technology capabilities.</h6>
                                <h6>We take care of order fulfillment, collection, transport, tracking and delivery of parcels. We are the first in Bangladesh to have created a unique network with home delivery and Store Pickup & Return services which enhances customer experience and rationalizes costs.</h6>
                                <p>Our 10 offices and over 350+ employees with 50 channel partners deliver for more than 25,000 companies, businesses, and individuals.</p>
                            </div>
                       </div>
                    </div>
                </div>
            </section>
        </>
    )
}
